// SpinShot logo processing indicator
// Rotates the SpinShot logo whenever any variant in the current list is actively processing.

const PROCESSING_STATUSES = [
    "processing",
    "uploading",
    "validating",
    "rendering",
    "upscaling",
    "remeasuring",
    "reverting"
];

function anyVariantProcessing() {
    const table = document.querySelector("#variants_list");
    if (!table) return false;

    // Check for spinner icons in thumbnails (most reliable indicator)
    const spinnerIcons = table.querySelectorAll('.variant-preview .rotate, .variant-preview .rotate-clockwise');
    if (spinnerIcons.length > 0) return true;

    // Fallback: check data-image_status attributes
    const rows = table.querySelectorAll('tr[data-image_status]');
    return Array.from(rows).some((row) => {
        const status = row.getAttribute('data-image_status');
        return status && PROCESSING_STATUSES.includes(status);
    });
}

function setLogoProcessing(active) {
    document.querySelectorAll(".navbar .spinshot-logo-o").forEach((path) => {
        path.classList.toggle("rotate-clockwise", active);
    });
}

function refreshLogoProcessingState() {
    setLogoProcessing(anyVariantProcessing());
}

// Make function globally accessible for other modules
window.refreshLogoProcessingState = refreshLogoProcessingState;

// Initial load + Turbo-driven navigation updates
document.addEventListener("turbo:load", refreshLogoProcessingState);
document.addEventListener("DOMContentLoaded", refreshLogoProcessingState);

// When frames update, re-evaluate processing state
document.addEventListener("turbo:frame-load", () => {
    refreshLogoProcessingState();
    setupObserver();
});

// Watch for changes to the variants list table
let observer = null;

function setupObserver() {
    if (observer) observer.disconnect();

    const table = document.querySelector("#variants_list");
    if (!table) return;

    observer = new MutationObserver(() => {
        refreshLogoProcessingState();
    });

    observer.observe(table, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-image_status']
    });
}

// Also check periodically in case variants update without triggering events
let processingCheckInterval = null;

function startPeriodicCheck() {
    if (processingCheckInterval) return;
    processingCheckInterval = setInterval(refreshLogoProcessingState, 2000);
}

function stopPeriodicCheck() {
    if (processingCheckInterval) {
        clearInterval(processingCheckInterval);
        processingCheckInterval = null;
    }
}

function initializeLogoProcessing() {
    refreshLogoProcessingState();
    setupObserver();
    startPeriodicCheck();
}

// Initialize on page load
document.addEventListener("turbo:load", initializeLogoProcessing);
document.addEventListener("DOMContentLoaded", initializeLogoProcessing);

// Cleanup on navigation
document.addEventListener("turbo:before-visit", () => {
    stopPeriodicCheck();
    if (observer) {
        observer.disconnect();
        observer = null;
    }
});

